import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

const DetallesCalculos = ({
    showModalNuevo,
    Editar,
    cargando,
    formData,
    formErrors,
    handleChange,
    selectedGasto,
    tipoDeCambio,
    setTipoDeCambio,
    tipoDeCambioTexto
}) => {
    return (
        <Col xs={12} sm={6}>
            {/* Tipo de Moneda y Tipo de Cambio */}
            <Row>
                <Col xs={6} sm={6} className="mb-2 mt-lg-0">
                    <Form.Group>
                        <Form.Label>Tipo de Moneda</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Select
                                        value={formData.idTipoMoneda || ""}
                                        onChange={(e) => {
                                            const nuevaMoneda = e.target.value;
                                            handleChange("idTipoMoneda", nuevaMoneda);

                                            if (nuevaMoneda === "1") {
                                                handleChange("dTipoCambio", 1);
                                            } else {
                                                handleChange("dTipoCambio", tipoDeCambio.USD_CAMBIADO)
                                            }
                                        }}
                                        autoComplete="off"
                                        type="text"
                                        size="sm"
                                        isInvalid={!!formErrors.vMoneda}
                                    >
                                        <option value={1}>MXN</option>
                                        <option value={2}>USD</option>
                                    </Form.Select>
                                )}
                                <Form.Text className="text-muted d-none d-lg-block">
                                    TC: {tipoDeCambioTexto}
                                </Form.Text>
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={formData.vMoneda || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.vMoneda}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col xs={6} className="mb-2 mt-lg-0">
                    <Form.Group>
                        <Form.Label>Tipo de Cambio</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    formData.idTipoMoneda === "1" ? (
                                        <Form.Control
                                            type="number"
                                            value={formData.dTipoCambio}
                                            autoComplete="off"
                                            size="sm"
                                            step="any"
                                            readOnly
                                        />
                                    ) : (
                                        <Form.Control
                                            type="number"
                                            value={formData.dTipoCambio}
                                            autoComplete="off"
                                            size="sm"
                                            step="any"
                                            min="0"
                                            title="El tipo de cambio es actual y puedes modificarlo"
                                            isInvalid={!!formErrors.idTipoCambio}
                                            onChange={(e) => {
                                                let nuevoValor = e.target.value;
                                                if (Number(nuevoValor) < 0) {
                                                    nuevoValor = "0";
                                                }

                                                setTipoDeCambio((prevState) => ({
                                                    ...prevState,
                                                    USD_CAMBIADO: nuevoValor,
                                                }));

                                                handleChange("dTipoCambio", nuevoValor);
                                            }}
                                        />
                                    )
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto.dTipoCambio || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.idTipoCambio}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            {/* Cantidad y Precio Unitario */}
            <Row>
                <Col xs={6} sm={6} className="mb-2">
                    <Form.Group>
                        <Form.Label>Cantidad</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        value={formData.dCantidad || ""}
                                        onChange={(e) => {
                                            let nuevoValor = e.target.value;
                                            if (Number(nuevoValor) < 0) {
                                                nuevoValor = "0";
                                            }
                                            handleChange("dCantidad", nuevoValor)
                                        }}
                                        autoComplete="off"
                                        type="number"
                                        min="0"
                                        step="any"
                                        isInvalid={!!formErrors.dCantidad}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.dCantidad || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.dCantidad}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col xs={6}>
                    <Form.Group>
                        <Form.Label>
                            <span className="d-inline d-sm-none">Precio Unitario</span>
                            <span className="d-none d-sm-inline d-lg-none">Precio Uni...</span>
                            <span className="d-none d-lg-inline">Precio Unitario</span>
                        </Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="number"
                                        step="0.01"
                                        isInvalid={!!formErrors.dPrecioUnitario}
                                        value={formData.dPrecioUnitario || ""}
                                        min="0"
                                        onChange={(e) => {
                                            let nuevoValor = e.target.value;
                                            if (Number(nuevoValor) < 0) {
                                                nuevoValor = "0";
                                            }
                                            handleChange("dPrecioUnitario", nuevoValor)
                                        }}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.dPrecioUnitario || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.dPrecioUnitario}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            {/* Tipo Factor IVA y Tasa Cuota IVA */}
            <Row>
                <Col xs={6} sm={6} className="mb-2">
                    <Form.Group>
                        <Form.Label>Tipo Factor IVA</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Select
                                        size="sm"
                                        value={formData.vTipoFactorIva || ""}
                                        isInvalid={!!formErrors.vTipoFactorIva}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            handleChange("vTipoFactorIva", selectedValue);

                                            if (selectedValue === "Tasa") {
                                                handleChange("dTasaCuotaIva", "0.00");
                                            } else if (selectedValue === "Exento") {
                                                handleChange("dTasaCuotaIva", "0");
                                            } else {
                                                handleChange("dTasaCuotaIva", "0");
                                            }
                                        }}
                                    >
                                        <option value="">Seleccione una tasa</option>
                                        <option value="Tasa">Tasa</option>
                                        <option value="Cuota">Cuota</option>
                                        <option value="Exento">Exento</option>
                                    </Form.Select>
                                )}
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.vTipoFactorIva}
                                </Form.Control.Feedback>
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.vTipoFactorIva || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                    </Form.Group>
                </Col>

                <Col xs={6}>
                    <Form.Group>
                        <Form.Label>Tasa Cuota IVA</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="number"
                                        disabled={formData.vTipoFactorIva === "Exento"}
                                        value={formData.dTasaCuotaIva !== undefined && formData.dTasaCuotaIva !== null ? formData.dTasaCuotaIva : ""}
                                        onChange={(e) => {
                                            let nuevoValor = e.target.value;
                                            if (Number(nuevoValor) < 0) {
                                                nuevoValor = "0";
                                            }
                                            handleChange("dTasaCuotaIva", nuevoValor)
                                        }}
                                        isInvalid={!!formErrors.dTasaCuotaIva}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={formData.dTasaCuotaIva !== undefined && formData.dTasaCuotaIva !== null ? formData.dTasaCuotaIva : ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.dTasaCuotaIva}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            {/* IVA y IVA RET */}
            <Row>
                <Col xs={6} className="mb-2 mb-md-0">
                    <Form.Group>
                        <Form.Label>IVA</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        value={formData.dIva}
                                        disabled={formData.vTipoFactorIva === "Exento"}
                                        readOnly
                                        isInvalid={!!formErrors.dIva}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.dIva || "0"}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.dIva}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col xs={6}>
                    <Form.Group>
                        <Form.Label>IVA RET</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        value={formData.dIvaRet}
                                        onChange={(e) => handleChange("dIvaRet", e.target.value)}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={formData.dIvaRet}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* ISR RET y Descuento */}
            <Row>
                <Col xs={6} className="mb-2 mb-md-0">
                    <Form.Group>
                        <Form.Label>ISR RET</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        value={formData.dIsrRet}
                                        onChange={(e) => handleChange("dIsrRet", e.target.value)}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.dIsrRet || "0"}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.dIsrRet}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col xs={6}>
                    <Form.Group>
                        <Form.Label>Descuento</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        value={formData.dDescuento}
                                        onChange={(e) => handleChange("dDescuento", e.target.value)}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={formData.dDescuento}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* Importe y Total */}
            <Row>
                <Col xs={6} className="mb-2 mb-md-0">
                    <Form.Group>
                        <Form.Label>Importe</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        type="number"
                                        value={formData.dImporte || ""}
                                        readOnly
                                        placeholder="0"
                                        size="sm"
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.dImporte || ""}
                                        readOnly
                                    />
                                )}
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.dImporte}
                                </Form.Control.Feedback>
                            </>
                        )}
                    </Form.Group>
                </Col>

                <Col xs={6}>
                    <Form.Group>
                        <Form.Label>Total</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        type="number"
                                        value={formData.dTotal !== undefined && formData.dTotal !== null ? formData.dTotal : ""}
                                        readOnly
                                        placeholder="0"
                                        size="sm"
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto.dTotal !== undefined && selectedGasto.dTotal !== null ? selectedGasto.dTotal : ""}
                                        readOnly
                                    />
                                )}
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.dTotal}
                                </Form.Control.Feedback>
                            </>
                        )}
                    </Form.Group>
                </Col>
            </Row>
        </Col>
    );
};

DetallesCalculos.propTypes = {
    showModalNuevo: PropTypes.bool,
    Editar: PropTypes.bool,
    cargando: PropTypes.bool,
    formData: PropTypes.object.isRequired,
    formErrors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    selectedGasto: PropTypes.object,
    tipoDeCambio: PropTypes.object.isRequired,
    setTipoDeCambio: PropTypes.func.isRequired,
    tipoDeCambioTexto: PropTypes.string
};

export default DetallesCalculos;
